const { default: axiosClient } = require('./axiosClient')
const deductionDocumentsApi = {
  find: (params) => {
    const url = '/deductionDocuments/find'
    return axiosClient.get(url, { params })
  },
}

export default deductionDocumentsApi
